import { useEffect } from 'react';
import { useLocalization } from '../context/LocalizationContext';
import parentFrameMessaging from '../services/ParentFrameMessaging';

export function useLocaleMessaging() {
  const { setLanguage, setCountry, setConfig, setCookieStatus } = useLocalization();

  useEffect(() => {
    const unsubscribe = parentFrameMessaging.onHandshake((data) => {
      // Extract language from Shopify locale (e.g., 'en-US' -> 'EN')
      if (data.locale) {
        const language = data.locale.split('-')[0].toUpperCase();
        setLanguage(language);
      }

      // Extract country from Shopify locale or use country field
      if (data.country) {
        setCountry(data.country.toUpperCase());
      } else if (data.locale && data.locale.includes('-')) {
        // Fallback: extract country from locale (e.g., 'en-US' -> 'US')
        const countryFromLocale = data.locale.split('-')[1];
        if (countryFromLocale) {
          setCountry(countryFromLocale.toUpperCase());
        }
      }

      // Set cookie status from the handshake
      if (data.cookies !== undefined) {
        setCookieStatus(data.cookies);
      }
    });

    return unsubscribe;
  }, [setLanguage, setCountry, setConfig, setCookieStatus]);

  return {
    // This hook doesn't return any state, it just listens and updates context
    // You could add debugging info here if needed
  };
}
